import React, { useEffect, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { sendEmail } from "../../../library/upload/UploadRequests"
import stylesheet from "../ShareSheet.module.scss"
import ReactGA from "react-ga"
import { UploadLayout } from "../../.."

interface EmailFormProps {
  uploadCode: string
  formatMediaForInstagram: boolean
  layout: UploadLayout
  onClose: () => void
}

export default function EmailForm({ uploadCode, formatMediaForInstagram, layout, onClose }: EmailFormProps) {
  const [email, setEmail] = useState(null)
  const [emailErrorCode, setEmailErrorCode] = useState<number>(null)
  const [emailSent, setEmailSent] = useState<boolean>(null)

  const { t } = useTranslation()

  const isValidEmail = (email: string) => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email)
  }

  useEffect(() => {
    ReactGA.event({
      category: 'Share Sheet',
      action: 'Email Form Appear',
      label: layout
    })
  }, [])

  const handleSend = () => {
    ReactGA.event({
      category: 'Share Sheet',
      action: 'Send Email',
      label: layout
    })
    sendEmail(
      uploadCode,
      email,
      formatMediaForInstagram,
      () =>
        setEmailSent(true),
      setEmailErrorCode)
  }

  return (
    <div className={stylesheet.shareSheet}>
      <h2 className={stylesheet.heading}>{t("shareSheet.email.heading")}</h2>
      {emailSent ?
        <p>{t("shareSheet.email.success")}</p>
        :
        <>
          <p>{t("shareSheet.email.instructions")}</p>
          <input
            className={stylesheet.emailInput}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("shareSheet.email.placeholder")}
          />
          <div className={stylesheet.buttonRow}>
            <button
              className={stylesheet.grayButton}
              onClick={onClose}>{t("shareSheet.buttons.cancel")}</button>
            <button
              className={stylesheet.blueButton}
              disabled={!isValidEmail(email)}
              onClick={handleSend}
            >
              {t("shareSheet.email.send")}
            </button>
          </div>
          <p className={stylesheet.small}>
            <Trans i18nKey="shareSheet.email.privacyNote">
              PS. We'll only send you 1 email. <br />See our <a href="https://www.simplebooth.com/privacy-policy" target="_blank">Privacy Policy</a>
            </Trans>
          </p>
        </>
      }
      {emailErrorCode &&
        <p>
          <Trans i18nKey="shareSheet.error" values={{ errorCode: emailErrorCode }}>
            An error occurred (errorCode)
          </Trans>
        </p>
      }
    </div>
  )
}